import { AuthCookieService, FrontendUserCookieService } from 'services/cookie';

export const isAccessTokenSet = () => {
  return !!AuthCookieService.getUserId();
};

export const getUserTokenData = () => {
  const userId = AuthCookieService.getUserId();
  if (!userId) return null;

  const exp = FrontendUserCookieService.getExp();
  const isExpired = () => exp === null || exp * 1000 < Date.now();

  return {
    getLegacyUserIdIfValid: () => (isExpired() ? 0 : FrontendUserCookieService.getLegacyUserId()),
    getAccountIdIfValid: () => (isExpired() ? 0 : FrontendUserCookieService.getAccountId()),
    getUserIdIfValid: () => (isExpired() ? null : userId),
    isExpired,
  };
};
